import isPlainObject from 'isobject';

function resolveNamedMediaQuery(style, mediaQueryMap) {
  for (var property in style) {
    var value = style[property];

    if (isPlainObject(value)) {
      var resolvedValue = resolveNamedMediaQuery(value, mediaQueryMap);

      if (mediaQueryMap.hasOwnProperty(property)) {
        style[mediaQueryMap[property]] = resolvedValue;
        delete style[property];
      }
    }
  }

  return style;
}

export default function namedMediaQuery(mediaQueryMap) {
  return function (style) {
    return resolveNamedMediaQuery(style, mediaQueryMap);
  };
}